import React from 'react';
import QRCode from 'react-qr-code';
import { connect } from 'react-redux';
import cssModule from 'react-css-modules';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import {
  getQRCodeURL,
  getIsAutomatedChannel,
  getReadyMatchId,
  getMatchSportId,
} from 'reducers';
import { useImportImageNewDesign } from 'hooks';
import style from './QRCodeWrapper.scss';

const mapStateToProps = state => ({
  matchId: getReadyMatchId(state),
  qrCodeURL: getQRCodeURL(state),
  isAutomatedChannel: getIsAutomatedChannel(state),
  sportId: getMatchSportId(state, getReadyMatchId(state)),
});

const QRCodeWrapper = ({
  matchId, sportId, qrCodeURL, isAutomatedChannel,
}) => {
  const intl = useIntl();
  const qrphone = useImportImageNewDesign('general/QRPhone.png');

  if (!qrCodeURL) {
    return null;
  }

  let resolvedQrCodeURL = qrCodeURL;
  if (isAutomatedChannel) {
    resolvedQrCodeURL = resolvedQrCodeURL
      .replace('[SRmatchID]', String(matchId))
      .replace('[SRsportID]', String(sportId));
  }

  // TODO: log for testing
  console.log('resolvedQrCodeURL', resolvedQrCodeURL);

  return (
    <div
      className='flex w-1/5'
      styleName='qrcode__main_wrapper'
    >
      <div className='flex flex-col items-center justify-center mr-2 ml-4' styleName='qrcode__textarea'>
        <span className='font-main--bold mb-2'>{intl.formatMessage({ id: 't_footer_qrcode_place_bet' })}</span>
        <span className='italic font-main--bold'>{intl.formatMessage({ id: 't_footer_qrcode_scan_me' })}</span>
        <img src={qrphone} alt={'Linkedin icon'} />
      </div>
      <div className={'mr-4'} styleName='qrcode__wrapper'>
        <QRCode
          value={resolvedQrCodeURL}
          bgColor='#fff'
          fgColor='#000'
        />
      </div>
    </div>
  );
};

QRCodeWrapper.propTypes = {
  qrCodeURL: PropTypes.string,
  matchId: PropTypes.number,
  sportId: PropTypes.number,
  isAutomatedChannel: PropTypes.number.isRequired,
};

QRCodeWrapper.defaultProps = {
  qrCodeURL: null,
  matchId: null,
  sportId: null,
};

const QRCodeWrapperStyled = cssModule(QRCodeWrapper, style);
export default connect(mapStateToProps)(QRCodeWrapperStyled);
